module.exports = __webpack_public_path__ + "img/logo.ed6a39ce.png";